import store from "../redux/store";

const etagCache = new Map();

export default async function fetcher(url) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 10000);

  try {
    const headers = {};

    const token = store.getState().auth?.token;
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const lastETag = etagCache.get(url);
    if (lastETag) {
      headers['If-None-Match'] = lastETag;
    }

    const response = await fetch(url, {
      credentials: 'include',
      headers,
      signal: controller.signal
    });

    clearTimeout(timeoutId);

    const newETag = response.headers.get('ETag');
    if (newETag) {
      etagCache.set(url, newETag);
    }

    if (response.status === 304) {
      const error = new Error('Not Modified');
      error.status = 304;
      throw error;
    }

    if (!response.ok) {
      const error = new Error(`HTTP error! status: ${response.status}`);
      error.status = response.status;
      throw error;
    }

    return response.json();
  } catch (error) {
    clearTimeout(timeoutId);
    if (error.name === 'AbortError') {
      throw new Error(`Request timed out after 10000 ms`);
    }
    throw error;
  }
}
